import { useStickyLabel } from '@/components';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

export const StickyChatLabel = ({ messages, inverted, scrollRef, stickyTypes }) => {
   const containerRef = useRef(null);

   const stickyLabels = useStickyLabel({
      containerRef,
      data: messages,
      inverted,
      stickyTypes,
   });

   // Sync containerRef when scrollRef is ready or messages change
   useEffect(() => {
      if (scrollRef.current) {
         containerRef.current = scrollRef.current.getScrollContainer?.();
      }
   }, [scrollRef, messages.length]);

   if (!stickyLabels.length) return null;

   return (
      <div className="sticky-chat-label-container ct-flex ct-fcol ct-aiCenter ct-gap6">
         {stickyLabels.map(sticky => (
            <div
               key={`${sticky.type}-${sticky.label}`}
               className={`sticky-chat-label ct-inlineFlex ct-aiCenter ct-jcCenter chat-label--${sticky.type}`}
            >
               <span>{sticky.label}</span>
            </div>
         ))}
      </div>
   );
};

StickyChatLabel.propTypes = {
   messages: PropTypes.array.isRequired,
   inverted: PropTypes.bool.isRequired,
   scrollRef: PropTypes.object.isRequired,
   stickyTypes: PropTypes.arrayOf(PropTypes.string),
};

StickyChatLabel.defaultProps = {
   stickyTypes: ['date-label', 'unread-separator'],
};
